import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { ADMIN } from "../../constants/testIds";
import { LayoutGrid, FileText, Layers, Users, Video, LogOut, ExternalLink, BookOpen, GraduationCap, Image } from "lucide-react";

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  const items = [
    { to: "/admin", label: "Panel", icon: LayoutGrid, tid: "admin-nav-home", end: true },
    { to: "/admin/sorular", label: "Sorular", icon: FileText, tid: ADMIN.navQuestions },
    { to: "/admin/konular", label: "Konular", icon: Layers, tid: ADMIN.navTopics },
    { to: "/admin/mufredat", label: "Müfredat", icon: Layers, tid: "admin-nav-curriculum" },
    { to: "/admin/katalog", label: "Katalog", icon: BookOpen, tid: "admin-nav-catalog" },
    { to: "/admin/gorseller", label: "Görsel Yönetimi", icon: Image, tid: "admin-nav-images" },
    { to: "/admin/etiketler", label: "Etiketler", icon: Layers, tid: ADMIN.navTags },
    { to: "/admin/ogrenciler", label: "Öğrenciler", icon: Users, tid: ADMIN.navStudents },
    { to: "/admin/ogretmen-basvurulari", label: "Öğretmen Başvuruları", icon: GraduationCap, tid: "admin-nav-teacher-apps" },
  ];
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#FAFAFA]">
      <div className="grid grid-cols-[minmax(0,1fr)] md:grid-cols-[240px_minmax(0,1fr)] min-h-screen">
        <aside className="border-r border-[#262626] bg-[#0A0A0A] md:sticky md:top-0 md:h-screen">
          <div className="p-5 border-b border-[#262626]">
            <div className="font-display text-xl tracking-tight">
              <span>Matematik</span> <span className="text-[#EA580C]">Koçu</span>
            </div>
            <div className="text-xs text-slate-400 mt-0.5 font-mono">YÖNETİM</div>
          </div>
          <nav className="p-2 space-y-1">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.tid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors ${
                    isActive ? "bg-[#EA580C] text-white" : "text-slate-300 hover:bg-[#171717]"
                  }`
                }>
                <it.icon size={16}/> {it.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-auto p-3 space-y-1 border-t border-[#262626]">
            <NavLink to="/" className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-slate-300 hover:bg-[#171717]">
              <ExternalLink size={16}/> Öğrenci Görünümü
            </NavLink>
            <button onClick={async () => { await logout(); nav("/giris"); }}
              className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-slate-300 hover:bg-[#171717]">
              <LogOut size={16}/> Çıkış
            </button>
            <div className="px-3 pt-2 text-xs text-slate-500">{user?.email}</div>
          </div>
        </aside>
        <main className="p-5 sm:p-8 max-w-6xl mx-auto w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
